/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Steamfitter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SystemPermission = 'CreateScenarioTemplates' | 'ViewScenarioTemplates' | 'EditScenarioTemplates' | 'ManageScenarioTemplates' | 'CreateScenarios' | 'ViewScenarios' | 'EditScenarios' | 'ExecuteScenarios' | 'ManageScenarios' | 'ManageTasks' | 'ViewUsers' | 'ManageUsers' | 'ViewRoles' | 'ManageRoles' | 'ViewGroups' | 'ManageGroups';

export const SystemPermission = {
    CreateScenarioTemplates: 'CreateScenarioTemplates' as SystemPermission,
    ViewScenarioTemplates: 'ViewScenarioTemplates' as SystemPermission,
    EditScenarioTemplates: 'EditScenarioTemplates' as SystemPermission,
    ManageScenarioTemplates: 'ManageScenarioTemplates' as SystemPermission,
    CreateScenarios: 'CreateScenarios' as SystemPermission,
    ViewScenarios: 'ViewScenarios' as SystemPermission,
    EditScenarios: 'EditScenarios' as SystemPermission,
    ExecuteScenarios: 'ExecuteScenarios' as SystemPermission,
    ManageScenarios: 'ManageScenarios' as SystemPermission,
    ManageTasks: 'ManageTasks' as SystemPermission,
    ViewUsers: 'ViewUsers' as SystemPermission,
    ManageUsers: 'ManageUsers' as SystemPermission,
    ViewRoles: 'ViewRoles' as SystemPermission,
    ManageRoles: 'ManageRoles' as SystemPermission,
    ViewGroups: 'ViewGroups' as SystemPermission,
    ManageGroups: 'ManageGroups' as SystemPermission
};

